module.exports = __webpack_public_path__ + "static/media/js.0cded3a3.png";